import API from "./index.js"

const API_URL = "/api/autorizacao-compra"

class AutorizacaoCompraService {
    findAll(params) {
        return API.get(API_URL, { params })
    }

    findById(id) {
        return API.get(`${API_URL}/${id}`)
    }

    create(data) {
        return API.post(API_URL, data)
    }

    update(id, data) {
        return API.put(`${API_URL}/${id}`, data)
    }

    updateStatus(id, statusId) {
        return API.put(`${API_URL}/${id}/status`, null, { params: { statusId } })
    }

    delete(id) {
        return API.delete(`${API_URL}/${id}`)
    }

    findAllDetalhado(params) {
        return API.get(`${API_URL}/detalhado`, { params })
    }
}

export default new AutorizacaoCompraService()
